module.exports = __webpack_public_path__ + "img/help1.1875561a.png";